/* ===========================================================================
   HN · set di saponi a scelta del cliente — dal 2026-10-07
   ---------------------------------------------------------------------------
   Sui Set da 3, 5 e 7 il cliente può scegliere i saponi (anche ripetuti) invece
   della selezione consigliata, allo stesso prezzo. Merchant, 2026-10-07: «voglio
   dare la possibilità di scegliere ma la pagina deve convertire nuova gente».

   ⚠️ Dal 2026-10-08 la pagina dice UNA cosa sola: i saponi che arriveranno, in
   un riquadro unico da toccare (tondo, «I tuoi 3 saponi», nomi),
   uguale per il predefinito e per la scelta del cliente (merchant: «vorrei che ci sia solo scritto quello che è attualmente
   scelto a prescindere se sia il default o selezionato dal cliente»). Niente
   combinazioni da scegliere: il selettore del tema e i tondini (hn-swatch) qui
   non si vedono. Il PREDEFINITO lo dà il sistema, non lo SKU: i primi N saponi
   disponibili nell'ordine del pannello, e se non bastano si raddoppia dall'alto
   (base()). Con tutto disponibile coincide con la Combinazione 1 e coi Set da 5
   e da 7. La riga arriva già scritta dallo snippet (stessa regola), così non
   spinge giù la pagina quando il JS la ridisegna.

   ⚠️ La scelta NON è una variante: sono proprietà della riga del carrello,
   scritte nel modulo VERO del prodotto (#product-form-<pid>) solo quando i
   saponi sono DIVERSI da quelli che lo SKU della variante spedisce (notes()) —
   cioè quando il cliente ha scelto, o quando il predefinito ha sostituito un
   sapone esaurito:
     - «Saponi scelti» = «2× Nèttare, 1× Espresso Zen, 2× Scirocco»: la leggono
       cliente (carrello, pagamento) e chi prepara il pacco;
     - «_hn_sc» = «<pid>:<n>,…»: nascosta (inizia con _), la legge il motore del
       carrello (assets/hn-cart.js, lineScents) e l'analisi;
     - «_hn_sv» = «<variantId>:<n>:<prezzo in centesimi>,…»: nascosta, la legge
       Shopify Flow per scomporre l'ordine in saponi singoli, perché la logistica
       (Amphora) lavora per SKU (tools/flow/hn-split.js, tools/hn-bys-flow.md).
       Variante e prezzo stanno qui perché Flow legge solo l'ordine, e nell'ordine
       i saponi scelti non ci sono ancora;
     - «_hn_bys» = «c» (scelti dal cliente) o «d» (predefinito con un esaurito
       saltato): nascosta, la legge solo l'analisi.
   Così ogni altra strada che aggiunge il set (griglia, upsell, offerta al
   checkout) aggiunge il set consigliato, che è sempre un set valido.

   ⚠️ Sono <textarea>, non <input>: theme.js (actionAddToCart2) costruisce
   FormData dal modulo E ci aggiunge ogni input[name^="properties"] della
   pagina: un <input> dentro il modulo partirebbe due volte.

   ⚠️ Al tocco su «Aggiungi» del pannello si CLICCA IL BOTTONE VERO del tema,
   come fa la barra d'acquisto: stessa strada d'aggiunta (theme.js, o la
   guardia snippets/hn-atc-guard.liquid se il tema non è ancora pronto).

   ⚠️ Un sapone ESAURITO come singolo non entra mai in una scelta (merchant,
   2026-10-08). Un set scelto Flow lo spedisce coi saponi singoli, e Shopify
   aggiunge senza errori anche un singolo esaurito (tools/hn-bys-flow.md §1):
   l'unico posto dove fermarlo è qui. Nel pannello sta a 0, e il predefinito lo
   salta (per il Set da 3 senza Scirocco: il quarto). Siccome quel predefinito è
   diverso dallo SKU, la riga porta le note e Flow spedisce i saponi disponibili.

   ⚠️ Dal 2026-10-09 la REGOLA del predefinito e il FORMATO delle note stanno nel
   motore del carrello (assets/hn-cart.js, HNCart.bys), non qui: il set si aggiunge
   anche da griglia, consigliati, blocchi sotto il bottone e offerta al checkout, e
   solo una di queste strade passava da questo file (#IT219669: set standard con lo
   Scirocco esaurito dentro). Qui si chiede al motore (base, sku, props) e si disegna;
   se il motore non c'e' o non conosce il set, il modulo si arrende (why) e il set si
   compra come prima. Una regola in due posti e' il difetto numero uno di questo repo.

   Diagnostica: data-hn-bys-why sul contenitore, ?hnbysdebug=1 lo stampa.
   =========================================================================== */
(function () {
  'use strict';
  var DEBUG = /[?&]hnbysdebug=1(&|$)/.test(window.location.search || '');
  var COLOR = /^#[0-9a-f]{3,8}$/i;
  var SCRUB = { nessuno: 0, lieve: 1, moderato: 2, vigoroso: 3 };
  var M = null;                       // un solo set per pagina
  var SH = { root: null, card: null, open: false, pushed: false, ignorePop: false, y: 0, pad: '', trigger: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function design() { return !!(window.Shopify && window.Shopify.designMode); }
  function push(ev, extra) {
    if (design()) return;
    try {
      var o = { event: ev, hn_bys_pid: String(M.pid), hn_bys_n: M.n };
      for (var k in extra) if (extra.hasOwnProperty(k)) o['hn_bys_' + k] = extra[k];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(o);
    } catch (e) { /* la misura non rompe mai niente */ }
  }
  /* Il modulo si arrende: la riga scritta dallo snippet se ne va e torna ciò che
     c'era prima, cioè il selettore delle combinazioni del tema (lo snippet lo
     nasconde con <style data-hn-bys-hide>) e i tondini, che si erano fatti da parte
     finché questo contenitore non diceva il motivo. Il set si compra come sempre. */
  function why(host, msg) {
    host.setAttribute('data-hn-bys-why', msg);
    host.hidden = true;
    var st = document.querySelectorAll('style[data-hn-bys-hide]');
    for (var i = 0; i < st.length; i++) st[i].parentNode.removeChild(st[i]);
    try { if (window.HNSwatch && window.HNSwatch.run) window.HNSwatch.run(); } catch (e) { /* resta il selettore del tema */ }
    if (DEBUG) { host.hidden = false; host.innerHTML = '<p class="hn-bys__dbg">hn-bys: ' + esc(msg) + '</p>'; }
    return false;
  }

  /* ----------------------------------------------------------- dati */
  function curVid() { return M.input ? String(M.input.value) : ''; }
  /* La regola del predefinito e il formato delle note stanno nel MOTORE del carrello
     (HNCart.bys, assets/hn-cart.js): qui non se ne tiene una copia. */
  function E() { return window.HNCart && window.HNCart.bys && window.HNCart.bys.enabled() ? window.HNCart.bys : null; }
  /* Cosa spedisce lo SKU della variante nel modulo: la composizione del catalogo
     (la stessa del carrello e di Amphora). Serve solo a decidere se la riga deve
     portare le note: la pagina non la mostra piu'. */
  function curated() { return E().sku(M.pid, curVid()); }
  /* Il set PREDEFINITO (merchant, 2026-10-08: «il default lo dà il sistema: per il
     set da 3 i primi 3 in alto, e se Scirocco non c'è prende il 4»): i primi N
     saponi disponibili nell'ordine del pannello, a giro, quindi se non bastano si
     raddoppia dall'alto («set da 7 e sono soldout 4 tipi: i primi 2 hanno quantità
     2»). Lo calcola il motore; la stessa regola la scrive lo snippet per la riga di
     partenza (in Liquid, perche' la pagina non salti: PD91). */
  function base() { return E().base(M.pid); }
  function total(c) { var t = 0; for (var k in c) if (c.hasOwnProperty(k)) t += c[k]; return t; }
  function same(a, b) { return E().same(a, b); }
  // i saponi in ordine di pannello (l'ordine del merchant), ripetuti quante volte sono scelti
  function expand(c) {
    var out = [];
    M.soaps.forEach(function (s) { for (var i = 0; i < (c[s.id] || 0); i++) out.push(s); });
    return out;
  }
  function names(c, sep) {
    return M.soaps.filter(function (s) { return c[s.id]; }).map(function (s) {
      return (c[s.id] > 1 ? c[s.id] + '× ' : '') + s.t;
    }).join(sep);
  }
  // per la riga in pagina: ogni nome resta intero, si va a capo solo dopo «· » (come lo snippet)
  function namesHTML(c) {
    return M.soaps.filter(function (s) { return c[s.id]; }).map(function (s) {
      return (c[s.id] > 1 ? c[s.id] + '×&nbsp;' : '') + esc(s.t).replace(/ /g, '&nbsp;');
    }).join('&nbsp;· ');
  }
  /* Le note della riga per quella scelta (motore: «Saponi scelti», `_hn_sc`, `_hn_sv`,
     `_hn_bys`), in lista [nome, valore]. «_hn_bys» dice CHI ha deciso quei saponi: «c» il
     cliente (ha cambiato il predefinito), «d» il sistema (il predefinito che salta un
     esaurito). Serve all'analisi: senza, finche' un sapone e' esaurito ogni set venduto
     sembrerebbe scelto dal cliente (tools/hn-bys-report.mjs). Flow non lo legge. */
  function propList(c) {
    var o = E().props(M.pid, c, same(c, base()) ? 'd' : 'c');
    return o ? Object.keys(o).map(function (k) { return [k, o[k]]; }) : null;
  }
  /* Le note della riga, solo quando i saponi sono DIVERSI da quelli che lo SKU della
     variante spedisce: senza note Amphora spedisce la composizione del suo SKU, che
     in quel caso è già la stessa. Altrimenti (scelta del cliente, o predefinito che
     ha saltato un esaurito) le note ci vogliono, perché Flow spedisca questi. */
  function notes() { return M.sel && !same(M.sel, curated()) ? propList(M.sel) : null; }
  function discOf(c) {
    var list = expand(c).map(function (s) { return M.D.p[s.id]; });
    return window.HNSwatch && window.HNSwatch.disc ? window.HNSwatch.disc(list) : '';
  }
  function price() { return (M.cfg.vs && M.cfg.vs[curVid()]) || ''; }

  /* ------------------------------------------- campi nel modulo del tema */
  function fields() {
    if (!M.form || !document.documentElement.contains(M.form)) {
      M.form = document.getElementById('product-form-' + M.pid);
      M.input = M.form && M.form.querySelector('[name="id"]');
    }
    var form = M.form;
    if (!form) return;
    var olds = form.querySelectorAll('[data-hn-bys-field]');
    for (var i = 0; i < olds.length; i++) olds[i].parentNode.removeChild(olds[i]);
    var pl = notes();
    if (!pl) return;
    pl.forEach(function (p) {
      var t = document.createElement('textarea');
      t.name = 'properties[' + p[0] + ']';
      t.value = p[1];
      t.hidden = true;
      /* ⚠️ `hidden` da solo NON basta: assets/base.css riaccende ogni textarea vuota
         (textarea:empty{display:block}, la toppa del tema al suo *:empty), e una regola
         del tema batte quella del browser per [hidden]. Il valore sta in .value e non in
         un nodo di testo, quindi la textarea è :empty: le tre note si vedevano sotto
         «Aggiungi al carrello» (merchant, 2026-10-08). In linea e !important, così vale
         anche prima che arrivi hn-bys.css. MAI `disabled`: toglierebbe le note dall'invio. */
      t.style.setProperty('display', 'none', 'important');
      t.setAttribute('aria-hidden', 'true');
      t.tabIndex = -1;
      t.setAttribute('data-hn-bys-field', '');
      form.appendChild(t);
    });
  }

  /* --------------------------------------------------- riga in pagina */
  /* Un riquadro solo, uguale per il predefinito e per la scelta del cliente, tutto
     da toccare: il tondo, «I tuoi 3 saponi» e i nomi. Dal 2026-10-25 senza il testo
     «Personalizza ›» (merchant: invitava a perdere tempo, e chi vuole cambiare i
     saponi tocca comunque): il testo c'è solo se l'impostazione hn_bys_cta lo scrive.
     Stessa struttura e stesso testo che scrive lo snippet, così ridisegnarlo non
     cambia l'altezza (PD91). */
  function render() {
    var t = M.cfg.tx;
    M.host.innerHTML = '<button type="button" class="hn-bys__card" data-hn-bys-open aria-haspopup="dialog">' +
        '<span class="hn-bys__disc" aria-hidden="true">' + discOf(M.sel) + '</span><span class="hn-bys__txt">' +
        '<span class="hn-bys__name">' + esc(String(t.label).replace('{n}', M.n)) + '</span> ' +
        '<span class="hn-bys__val" data-hn-bys-val>' + namesHTML(M.sel) + '</span>' +
        (t.cta ? ' <span class="hn-bys__cta">' + esc(t.cta) + '</span>' : '') + '</span></button>' +
      // ?hnbysdebug=1: quanti saponi (catalogo e titolo, che lo snippet usa per la riga di partenza) e se la riga porta le note
      (DEBUG ? '<p class="hn-bys__dbg">hn-bys: ok · ' + M.n + ' saponi (dal titolo: ' + esc(M.host.getAttribute('data-hn-bys-n')) + ') · note sulla riga: ' +
        (notes() ? 'sì' : 'no, è lo SKU') + '</p>' : '');
    try { document.dispatchEvent(new CustomEvent('hn:bys:change', { detail: { pid: M.pid, active: !!notes() } })); } catch (e) { /* niente */ }
  }
  // una selezione completa, oppure il predefinito
  function setSel(c) {
    M.sel = c && total(c) === M.n ? copy(c) : base();
    fields();
    render();
  }

  /* ---------------------------------------------------------- pannello */
  function lock() {
    var de = document.documentElement, b = document.body.style;
    SH.y = window.scrollY || window.pageYOffset || 0;
    var bar = window.innerWidth - de.clientWidth;
    SH.pad = b.paddingRight;
    de.style.overflow = 'hidden';
    b.position = 'fixed'; b.top = (-SH.y) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    if (bar > 0) b.paddingRight = bar + 'px';
  }
  function unlock() {
    var b = document.body.style;
    document.documentElement.style.overflow = '';
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.paddingRight = SH.pad || '';
    window.scrollTo(0, SH.y);
  }
  function scrubHTML(sx) {
    var lv = SCRUB[String(sx || '').trim().toLowerCase()];
    if (lv == null) return esc(sx);
    var bars = '';
    for (var i = 0; i < 3; i++) bars += '<i class="' + (i < lv ? 'is-on' : '') + '"></i>';
    return '<span class="hn-bys-r__bar" aria-hidden="true">' + bars + '</span> ' + esc(String(sx).toLowerCase());
  }
  /* L'invito al set SUCCESSIVO, al posto di «Ripristina la nostra selezione»
     (merchant, 2026-10-08: il Set da 3 spinge il Set da 5, il Set da 5 il Set da 7,
     in una riga). Il set viene dal catalogo (il set di saponi con più pezzi, non
     esaurito, più piccolo fra quelli più grandi di questo); il testo è un'impostazione
     (hn_bys_more, {sets} = il link). Senza un set successivo (il Set da 7) o col testo
     vuoto resta «Ripristina». Il link porta alla pagina del set: la scelta fatta qui non viaggia. */
  function nextSet() {
    var best = null, p = M.D.p;
    for (var id in p) {
      if (!p.hasOwnProperty(id)) continue;
      var e = p[id];
      if (e && e.cat === 'soapset' && e.su > M.n && e.av !== false && e.h && (!best || e.su < best.su)) {
        best = { id: String(id), su: e.su, h: e.h, n: String(e.n || '').replace(/\s+saponi$/i, '') || ('Set da ' + e.su) };
      }
    }
    return best;
  }
  function upHTML() {
    var t = M.cfg.tx.more, s = nextSet();
    if (!t || !s) return '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var link = '<a class="hn-bys-sh__upl" href="' + esc(root + 'products/' + s.h) + '" data-hn-bys-upto="' + esc(s.id) + '" data-hn-bys-upn="' + s.su + '">' + esc(s.n) + '</a>';
    var parts = String(t).split('{sets}');
    return parts.length > 1 ? esc(parts[0]) + link + esc(parts.slice(1).join('')) : esc(t) + ' ' + link;
  }
  function sheetHTML() {
    var t = M.cfg.tx, up = upHTML();
    var rows = M.soaps.map(function (s, i) {
      var lines = '';
      if (s.pf) lines += '<p class="hn-bys-r__l"><b>Profumo:</b> ' + esc(s.pf) + '</p>';
      // il tipo del sapone («Purificante con …», campo custom.hn_tipo) al posto di «Con:»; senza tipo resta «Con: …»
      if (s.tp || s.ing) lines += '<p class="hn-bys-r__l">' + (s.tp ? '<b>' + esc(s.tp) + '</b>' + (s.ing ? ' con ' + esc(s.ing) : '') : '<b>Con:</b> ' + esc(s.ing)) + '</p>';
      if (s.sx) lines += '<p class="hn-bys-r__l"><b>Scrub:</b> ' + scrubHTML(s.sx) + '</p>';
      return '<li class="hn-bys-r" data-hn-bys-row="' + i + '">' +
        '<span class="hn-bys-r__img">' + (s.i ? '<img src="' + esc(s.i) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>' +
        '<div class="hn-bys-r__txt"><p class="hn-bys-r__n">' + esc(s.t) + '<span class="hn-bys-r__out" data-hn-bys-out hidden>Esaurito</span></p>' + lines + '</div>' +
        '<div class="hn-bys-r__step" role="group" aria-label="' + esc(s.t) + '">' +
          '<button type="button" class="hn-bys-r__btn" data-hn-bys-dec="' + i + '" aria-label="Togli un ' + esc(s.t) + '">−</button>' +
          '<output class="hn-bys-r__q" data-hn-bys-q aria-live="polite">0</output>' +
          '<button type="button" class="hn-bys-r__btn" data-hn-bys-inc="' + i + '" aria-label="Aggiungi un ' + esc(s.t) + '">+</button>' +
        '</div></li>';
    }).join('');
    return '<div class="hn-bys-sh__head" data-hn-bys-head><span class="hn-bys-sh__grab"></span>' +
        '<p class="hn-bys-sh__t" id="hn-bys-t">' + esc(String(t.title).replace('{n}', M.n)) + '</p>' +
        '<span class="hn-bys-sh__count" data-hn-bys-count></span>' +
        '<button type="button" class="hn-bys-sh__x" data-hn-bys-close aria-label="Chiudi"><svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">' +
        '<path d="M4 4l10 10M14 4 4 14" style="fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round"/></svg></button></div>' +
      // la nota è facoltativa (vuota dal 2026-10-07): il «·» lo mette il CSS solo se c'è un testo
      '<p class="hn-bys-sh__note' + (up ? ' has-up' : '') + '"><span class="hn-bys-sh__nt" data-hn-bys-note>' + esc(t.note || '') + '</span>' +
        (up ? '<span class="hn-bys-sh__up" data-hn-bys-up>' + up + '</span>' :
          '<button type="button" class="hn-bys-sh__reset" data-hn-bys-reset>Ripristina la nostra selezione</button>') + '</p>' +
      '<div class="hn-bys-sh__body" data-hn-bys-body><ul class="hn-bys-sh__list" data-hn-bys-list>' + rows + '</ul></div>' +
      '<div class="hn-bys-sh__foot"><button type="button" class="hn-bys-sh__add" data-hn-bys-add></button></div>';
  }
  // quanti di un sapone si possono mettere: un esaurito nessuno (Flow lo spedirebbe dai singoli, che non ci sono)
  function maxOf(s) { return s.a ? M.n : 0; }
  function sheetSync() {
    var c = SH.c, tot = total(c), full = tot >= M.n;
    M.soaps.forEach(function (s, i) {
      var row = SH.card.querySelector('[data-hn-bys-row="' + i + '"]');
      if (!row) return;
      var q = c[s.id] || 0, cap = q >= maxOf(s);
      row.classList.toggle('is-on', q > 0);
      row.classList.toggle('is-out', !s.a);
      row.querySelector('[data-hn-bys-out]').hidden = !!s.a;
      row.querySelector('[data-hn-bys-q]').textContent = q;
      var dec = row.querySelector('[data-hn-bys-dec]'), inc = row.querySelector('[data-hn-bys-inc]');
      dec.disabled = q === 0;
      // pieno: il + resta toccabile (aria-disabled) per poter dire «togli un sapone»; esaurito: spento davvero
      inc.disabled = !s.a && cap;
      inc.setAttribute('aria-disabled', (full || cap) ? 'true' : 'false');
      inc.classList.toggle('is-off', full || cap);
    });
    SH.card.querySelector('[data-hn-bys-count]').textContent = tot + '/' + M.n;
    var add = SH.card.querySelector('[data-hn-bys-add]');
    add.disabled = tot !== M.n;
    var left = M.n - tot;
    add.textContent = tot === M.n ? 'Aggiungi al carrello' + (price() ? ' · ' + price() : '') :
      'Scegline ancora ' + left;
    if (!full) SH.card.querySelector('[data-hn-bys-note]').textContent = M.cfg.tx.note || '';
    SH.card.classList.toggle('is-full', full);
  }
  function hint() {
    var n = SH.card.querySelector('[data-hn-bys-note]');
    n.textContent = 'Togli un sapone per cambiarlo';
    var p = SH.card.querySelector('[data-hn-bys-count]');
    p.classList.remove('is-shake'); void p.offsetWidth; p.classList.add('is-shake');
  }
  function onSheetClick(e) {
    var t = e.target, x;
    if (!t || !t.closest) return;
    if (t.closest('[data-hn-bys-close]')) { e.preventDefault(); closeSheet(); return; }
    if ((x = t.closest('[data-hn-bys-inc]'))) {
      var s = M.soaps[+x.getAttribute('data-hn-bys-inc')];
      if (!s) return;
      if (total(SH.c) >= M.n) { hint(); return; }
      if ((SH.c[s.id] || 0) >= maxOf(s)) return;
      SH.c[s.id] = (SH.c[s.id] || 0) + 1;
      sheetSync(); return;
    }
    if ((x = t.closest('[data-hn-bys-dec]'))) {
      var s2 = M.soaps[+x.getAttribute('data-hn-bys-dec')];
      if (s2 && SH.c[s2.id]) { SH.c[s2.id]--; if (!SH.c[s2.id]) delete SH.c[s2.id]; }
      sheetSync(); return;
    }
    if (t.closest('[data-hn-bys-reset]')) { SH.c = copy(SH.cur); sheetSync(); return; }
    // l'invito al set più grande: è un link vero, si misura e si lascia andare
    if ((x = t.closest('[data-hn-bys-upto]'))) { push('hn_bys_up', { to: x.getAttribute('data-hn-bys-upto'), to_n: +x.getAttribute('data-hn-bys-upn') }); return; }
    if ((x = t.closest('[data-hn-bys-add]'))) { if (!x.disabled) addFromSheet(); }
  }
  function copy(c) { var o = {}; for (var k in c) if (c.hasOwnProperty(k)) o[k] = c[k]; return o; }
  function keys(e) {
    if (!SH.open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(SH.card.querySelectorAll('button:not([disabled])')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === SH.card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  function sheetRoot() {
    if (SH.root) return SH.root;
    var r = document.createElement('div');
    r.className = 'hn-bys-sh';
    r.setAttribute('data-hn-bys-sh', '');
    r.innerHTML = '<div class="hn-bys-sh__bg" data-hn-bys-close></div>' +
      '<div class="hn-bys-sh__card" role="dialog" aria-modal="true" aria-labelledby="hn-bys-t" tabindex="-1"></div>';
    document.body.appendChild(r);
    SH.root = r; SH.card = r.querySelector('.hn-bys-sh__card');
    r.addEventListener('click', onSheetClick);
    r.addEventListener('keydown', keys);
    // telefono: si chiude trascinando giù la testa
    var y0 = null, dy = 0;
    r.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('[data-hn-bys-head]') || e.target.closest('[data-hn-bys-close]')) return;
      y0 = e.touches[0].clientY; dy = 0; SH.card.style.transition = 'none';
    }, { passive: true });
    r.addEventListener('touchmove', function (e) {
      if (y0 == null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      SH.card.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    r.addEventListener('touchend', function () {
      if (y0 == null) return;
      y0 = null; SH.card.style.transition = ''; SH.card.style.transform = '';
      if (dy > 80) closeSheet();
    });
    window.addEventListener('popstate', function () {
      if (SH.ignorePop) { SH.ignorePop = false; return; }
      if (SH.open) closeSheet(true);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted && SH.open) closeSheet(true); });
    return r;
  }
  function openSheet(trigger) {
    var root = sheetRoot();
    if (SH.open) return;
    ['--hn-bys-acc', '--hn-bys-acc-t', '--hn-bys-ph', '--hn-bys-grey'].forEach(function (k) {
      var v = M.host.style.getPropertyValue(k); if (v) root.style.setProperty(k, v);
    });
    // «la nostra selezione» del pannello è il predefinito; si parte da ciò che la pagina mostra ora
    SH.cur = base();
    SH.start = copy(M.sel);
    SH.c = copy(SH.start);
    SH.trigger = trigger || null;
    SH.card.innerHTML = sheetHTML();
    sheetSync();
    SH.open = true;
    /* ⚠️ La voce di cronologia PRIMA del blocco dello scroll: tornando indietro il
       browser rimette lo scroll registrato per la voce di partenza, e se la pagina
       fosse già bloccata (scroll 0) la riporterebbe in cima (lezione di PD50). */
    try { history.pushState({ hnBys: 1 }, ''); SH.pushed = true; } catch (e) { SH.pushed = false; }
    lock();
    root.classList.add('is-open');
    void root.offsetHeight;
    requestAnimationFrame(function () { if (SH.open) root.classList.add('is-in'); });
    try { SH.card.focus({ preventScroll: true }); } catch (e) { /* niente */ }
    push('hn_bys_open', { active: notes() ? 1 : 0 });
  }
  function closeSheet(fromPop) {
    if (!SH.open) return;
    SH.open = false;
    // chiudendo, una scelta completa resta; una a metà no; e un pannello solo guardato non cambia niente
    if (total(SH.c) === M.n && !same(SH.c, SH.start)) setSel(SH.c);
    SH.root.classList.remove('is-in', 'is-open');
    SH.card.innerHTML = '';
    SH.card.style.transform = '';
    unlock();
    if (!fromPop && SH.pushed && history.state && history.state.hnBys) {
      SH.ignorePop = true;
      try { history.back(); } catch (e) { SH.ignorePop = false; }
    }
    SH.pushed = false;
    var t = SH.trigger; SH.trigger = null;
    if (t && t.focus && document.contains(t)) { try { t.focus({ preventScroll: true }); } catch (e) { /* niente */ } }
  }
  function changedCount(c, cur) {
    var n = 0;
    M.soaps.forEach(function (s) { var d = (c[s.id] || 0) - (cur[s.id] || 0); if (d > 0) n += d; });
    return n;
  }
  function addFromSheet() {
    var c = copy(SH.c), cur = SH.cur;
    // si chiude PRIMA di aggiungere: il carrello blocca lo scroll a sua volta
    closeSheet();
    setSel(c);
    var btn = M.form && M.form.querySelector('[data-btn-addtocart]');
    if (!btn || btn.disabled) return;
    // changed: saponi cambiati dal cliente rispetto al predefinito (0 = ha preso quello); active: la riga porta le note
    push('hn_bys_add', { changed: changedCount(c, cur), active: notes() ? 1 : 0 });
    // il bottone VERO: col tema pronto lo gestisce theme.js, prima la guardia
    btn.click();
  }

  /* ------------------------------------------------------------ avvio */
  function mount(host) {
    if (host.__hnBys) return true;
    var cfg = null;
    try { cfg = JSON.parse(host.getAttribute('data-hn-bys-cfg') || ''); } catch (e) { cfg = null; }
    if (!cfg || !cfg.pid) return why(host, 'configurazione illeggibile');
    var D = window.HN_CART_DATA;
    if (!D || !D.p) return why(host, 'catalogo assente');
    var pid = String(cfg.pid), e = D.p[pid];
    if (!e || e.cat !== 'soapset' || !(e.su > 0)) return why(host, 'il catalogo non lo conosce come set di saponi');
    if (!window.HNSwatch || !window.HNSwatch.disc) return why(host, 'manca il disegno dei tondi (hn-swatch.js)');
    var soaps = [];
    for (var i = 0; i < (cfg.soaps || []).length; i++) {
      var s = cfg.soaps[i], c = D.p[s.id];
      // mai un colore inventato: un sapone che il catalogo non sa disegnare ferma tutto
      if (!c || c.cat !== 'soap') return why(host, 'sapone ' + s.id + ' non è un sapone del catalogo');
      if (!COLOR.test(c.col || '') || (c.col2 && !COLOR.test(c.col2))) return why(host, 'sapone ' + s.id + ' senza colore');
      // senza variante e prezzo Flow non saprebbe cosa spedire: meglio il set di sempre
      if (!(c.vid > 0) || !(c.pr > 0)) return why(host, 'sapone ' + s.id + ' senza variante o prezzo nel catalogo');
      s.id = String(s.id);
      soaps.push(s);
    }
    if (soaps.length < 2) return why(host, 'meno di due saponi fra cui scegliere');
    // gli esauriti non si scelgono: con meno di due disponibili non c'è scelta, e il set si compra come prima
    if (soaps.filter(function (s) { return s.a; }).length < 2) return why(host, 'meno di due saponi disponibili');
    /* Il predefinito e le note li fa il motore del carrello (HNCart.bys): senza di lui, o se
       non conosce questo set, o se i suoi saponi non sono quelli di questo pannello (ordine e
       disponibilita'), il modulo non puo' garantire che la riga e il carrello dicano la stessa
       cosa: si arrende e il set si compra come prima. */
    var eng = E();
    if (!eng) return why(host, 'manca il motore del carrello (HN_CART_BOOT.bys)');
    if (!eng.has(pid)) return why(host, 'il motore del carrello non conosce questo set');
    var mine = eng.soaps.map(function (x) { return x.id + (x.a ? '+' : '-'); }).join();
    if (mine !== soaps.map(function (x) { return x.id + (x.a ? '+' : '-'); }).join()) return why(host, 'i saponi del motore non coincidono con quelli del pannello');
    var form = document.getElementById('product-form-' + pid);
    if (!form || !form.querySelector('[data-btn-addtocart]') || !form.querySelector('[name="id"]')) return why(host, 'manca il modulo del prodotto');
    // la selezione consigliata deve stare tutta fra i saponi del pannello, altrimenti «ripristina» non si potrebbe mostrare
    var known = {};
    soaps.forEach(function (s) { known[s.id] = 1; });
    var all = [].concat(e.sc || []);
    (e.vs || []).forEach(function (v) { all = all.concat(v.sc || []); });
    for (var k = 0; k < all.length; k++) if (!known[String(all[k])]) return why(host, 'sapone ' + all[k] + ' del set non è fra quelli del pannello');

    cfg.tx = cfg.tx || {};
    // una pagina rimasta in cache da prima del 2026-10-08 non ha l'etichetta nel JSON
    if (!cfg.tx.label) cfg.tx.label = 'I tuoi {n} saponi';
    M = { host: host, cfg: cfg, D: D, e: e, pid: pid, n: e.su, soaps: soaps, form: form, input: form.querySelector('[name="id"]'), sel: null };
    host.__hnBys = true;
    host.addEventListener('click', function (ev) {
      var o = ev.target && ev.target.closest && ev.target.closest('[data-hn-bys-open]');
      if (o) { ev.preventDefault(); openSheet(o); }
    });
    host.hidden = false;
    host.setAttribute('data-hn-bys-why', 'ok');
    var tap = host.hasAttribute('data-hn-bys-tap');
    host.removeAttribute('data-hn-bys-tap');
    // il predefinito, con le note se è diverso dallo SKU (un sapone esaurito saltato)
    setSel(null);
    // un tocco sul riquadro arrivato prima che il JS fosse pronto (la riga la scrive lo snippet): si apre ora
    if (tap) openSheet(host.querySelector('[data-hn-bys-open]'));
    return true;
  }

  function run() {
    var hosts = document.querySelectorAll('[data-hn-bys]');
    for (var i = 0; i < hosts.length; i++) {
      try { if (mount(hosts[i])) break; } catch (err) { why(hosts[i], 'errore: ' + (err && err.message)); }
    }
  }

  if (window.__HN_BYS_LOADED__) return;
  window.__HN_BYS_LOADED__ = true;

  /* La variante nel modulo può cambiare anche col selettore nascosto (URL, tema):
     i saponi mostrati restano quelli, ma le note dipendono dallo SKU della variante
     (notes()), quindi si riscrivono. Dopo il tema, che aggiorna il campo `id`. */
  document.addEventListener('change', function (ev) {
    if (!M || !ev.target || !ev.target.closest) return;
    if (ev.target.closest('variant-radios[data-product="' + M.pid + '"]') || ev.target.closest('variant-selects[data-product="' + M.pid + '"]') ||
        (ev.target.name === 'id' && ev.target.closest('#product-form-' + M.pid))) setTimeout(function () { if (M) { fields(); render(); } }, 0);
  }, true);
  /* I campi devono esserci al momento dell'aggiunta, qualunque cosa il tema abbia
     fatto al modulo nel frattempo: si riscrivono in CATTURA, prima di theme.js
     (clic delegato sul documento) e della guardia (invio, sulla window). */
  function ensure(ev) {
    if (!M || !M.sel || !ev.target || !ev.target.closest) return;
    var f = ev.target.closest('#product-form-' + M.pid);
    if (!f) return;
    if (ev.type === 'click' && !ev.target.closest('[data-btn-addtocart]')) return;
    M.form = f;
    var pl = notes(), have = f.querySelectorAll('[data-hn-bys-field]').length;
    if (have !== (pl ? pl.length : 0)) fields();
  }
  document.addEventListener('click', ensure, true);
  document.addEventListener('submit', ensure, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', function () { M = null; run(); });

  window.HNBys = {
    // le proprietà della riga per chi aggiunge il set da un'altra strada (pagina prodotto, gruppo B)
    // (solo quando servono: saponi diversi da quelli dello SKU, vedi notes())
    props: function (pid) {
      var pl = M && M.sel && String(pid) === M.pid ? notes() : null;
      if (!pl) return null;
      var o = {};
      pl.forEach(function (p) { o[p[0]] = p[1]; });
      return o;
    },
    // la riga porterà le note della scelta
    active: function (pid) { return !!(M && M.sel && String(pid) === M.pid && notes()); },
    // i saponi che arriveranno, per la barra d'acquisto: sempre, predefinito o scelta
    label: function (pid) { return M && M.sel && String(pid) === M.pid ? names(M.sel, ' · ') : ''; },
    why: function () { var h = document.querySelector('[data-hn-bys]'); return h ? h.getAttribute('data-hn-bys-why') : 'assente'; },
    _t: { state: function () { return M; }, sheet: function () { return SH; }, set: function (c) { setSel(c); } }
  };
})();
